import { Supplier } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const SUPPLIERS: Supplier[] = [
  {
    id: 'securitech-global',
    name: 'SecuriTech Global Solutions',
    logo: IMAGES.SECURITY_TECH_4,
    description: 'SecuriTech Global Solutions is a leading provider of advanced security screening technologies for airports worldwide. With over 25 years of experience, we specialize in X-ray baggage scanners, explosive detection systems, and full-body scanners that meet the highest international security standards. Our solutions are deployed in more than 150 airports across 45 countries, protecting millions of passengers daily. We combine cutting-edge technology with user-friendly interfaces to ensure efficient security operations without compromising passenger experience.',
    shortDescription: 'Leading provider of advanced security screening technologies for airports worldwide',
    products: ['X-ray Baggage Scanners', 'Explosive Detection Systems', 'Full-Body Scanners', 'Liquid Scanners'],
    categories: ['Security Screening', 'Terminal Equipment'],
    location: 'Singapore',
    country: 'Singapore',
    website: 'https://securitech-global.example.com',
    email: 'info@securitech-global.com',
    phone: '+65 6234 5678',
    founded: '1998',
    employees: '500-1000',
    certifications: ['ISO 9001:2015', 'TSA Approved', 'ECAC Certified', 'CE Marked'],
    featured: true,
    images: [IMAGES.SECURITY_TECH_4, IMAGES.SECURITY_SCREENING_8, IMAGES.AIRPORT_TERMINAL_5],
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
  },
  {
    id: 'aviation-access-systems',
    name: 'Aviation Access Systems',
    logo: IMAGES.SECURITY_TECH_5,
    description: 'Aviation Access Systems is a premier manufacturer of biometric access control and identity verification solutions designed specifically for airport environments. Our comprehensive product portfolio includes facial recognition systems, fingerprint scanners, iris recognition technology, and multi-factor authentication platforms. We serve over 200 airports globally, providing secure access control for restricted areas, staff authentication, and passenger verification. Our systems integrate seamlessly with existing airport infrastructure and comply with ICAO standards for biometric identification.',
    shortDescription: 'Premier manufacturer of biometric access control and identity verification solutions',
    products: ['Biometric Access Control', 'Facial Recognition Systems', 'ID Verification Kiosks', 'Perimeter Security'],
    categories: ['Access Control', 'Security Screening'],
    location: 'Hong Kong',
    country: 'Hong Kong',
    website: 'https://aviation-access.example.com',
    email: 'contact@aviation-access.com',
    phone: '+852 2345 6789',
    founded: '2005',
    employees: '200-500',
    certifications: ['ISO 27001', 'ICAO Compliant', 'GDPR Certified', 'SOC 2 Type II'],
    featured: true,
    images: [IMAGES.SECURITY_TECH_5, IMAGES.AIRPORT_TERMINAL_5, IMAGES.SECURITY_SCREENING_8],
  },
  {
    id: 'skywatch-surveillance',
    name: 'SkyWatch Surveillance Technologies',
    logo: IMAGES.AVIATION_2,
    description: 'SkyWatch Surveillance Technologies delivers state-of-the-art video surveillance and monitoring solutions for airport security operations. Our intelligent CCTV systems feature AI-powered video analytics, thermal imaging, and real-time threat detection capabilities. We provide comprehensive coverage for terminals, runways, perimeters, and cargo areas. Our solutions include centralized monitoring platforms, mobile surveillance units, and integration with existing security management systems. Trusted by major international airports, our technology helps security teams respond faster to incidents and maintain situational awareness across vast airport complexes.',
    shortDescription: 'State-of-the-art video surveillance and monitoring solutions for airport security',
    products: ['CCTV Systems', 'Video Analytics', 'Thermal Imaging', 'Drone Detection'],
    categories: ['Surveillance Systems', 'Cybersecurity'],
    location: 'Tokyo',
    country: 'Japan',
    website: 'https://skywatch-surveillance.example.com',
    email: 'sales@skywatch-surveillance.com',
    phone: '+81 3 1234 5678',
    founded: '2010',
    employees: '100-200',
    certifications: ['ISO 9001', 'IEC 62676', 'NDAA Compliant', 'UL Listed'],
    featured: true,
    images: [IMAGES.AVIATION_2, IMAGES.AIRPORT_TERMINAL_5, IMAGES.SECURITY_TECH_4],
  },
  {
    id: 'cybershield-aviation',
    name: 'CyberShield Aviation Security',
    logo: IMAGES.AIRPORT_TERMINAL_5,
    description: 'CyberShield Aviation Security specializes in comprehensive cybersecurity solutions for airport IT infrastructure and operational technology systems. We protect critical airport systems from cyber threats, including air traffic control networks, passenger information systems, baggage handling systems, and administrative networks. Our services include network security architecture, intrusion detection and prevention, security operations center (SOC) services, vulnerability assessments, and incident response. We help airports comply with aviation cybersecurity regulations and protect against evolving digital threats.',
    shortDescription: 'Comprehensive cybersecurity solutions for airport IT infrastructure',
    products: ['Network Security', 'Intrusion Detection', 'SOC Services', 'Vulnerability Management'],
    categories: ['Cybersecurity', 'Terminal Equipment'],
    location: 'Seoul',
    country: 'South Korea',
    website: 'https://cybershield-aviation.example.com',
    email: 'info@cybershield-aviation.com',
    phone: '+82 2 3456 7890',
    founded: '2012',
    employees: '150-300',
    certifications: ['ISO 27001', 'NIST Cybersecurity Framework', 'PCI DSS', 'CREST Certified'],
    featured: false,
    images: [IMAGES.AIRPORT_TERMINAL_5, IMAGES.SECURITY_TECH_5, IMAGES.AVIATION_2],
  },
  {
    id: 'terminal-tech-solutions',
    name: 'Terminal Tech Solutions',
    logo: IMAGES.SECURITY_SCREENING_8,
    description: 'Terminal Tech Solutions provides innovative passenger processing and terminal equipment for modern airports. Our product range includes self-service check-in kiosks, automated bag drop systems, boarding gate equipment, and passenger flow management solutions. We focus on enhancing passenger experience while improving operational efficiency. Our systems support contactless processing, mobile integration, and real-time data analytics. Deployed in over 100 airports worldwide, our solutions help reduce queue times, optimize staff allocation, and provide passengers with seamless travel experiences.',
    shortDescription: 'Innovative passenger processing and terminal equipment for modern airports',
    products: ['Check-in Kiosks', 'Bag Drop Systems', 'Boarding Gates', 'Queue Management'],
    categories: ['Terminal Equipment', 'Access Control'],
    location: 'Bangkok',
    country: 'Thailand',
    website: 'https://terminal-tech.example.com',
    email: 'contact@terminal-tech.com',
    phone: '+66 2 123 4567',
    founded: '2008',
    employees: '300-500',
    certifications: ['ISO 9001', 'IATA Certified', 'ACI Approved', 'CE Marked'],
    featured: false,
    images: [IMAGES.SECURITY_SCREENING_8, IMAGES.AIRPORT_TERMINAL_5, IMAGES.SECURITY_TECH_4],
  },
  {
    id: 'emergency-response-systems',
    name: 'Emergency Response Systems Asia',
    logo: IMAGES.SECURITY_TECH_4,
    description: 'Emergency Response Systems Asia is a trusted provider of fire safety, emergency communication, and crisis management solutions for airports. Our comprehensive systems include fire detection and suppression, emergency lighting, public address and general alarm (PAGA) systems, and mass notification platforms. We design, install, and maintain life safety systems that comply with international aviation fire safety standards. Our 24/7 monitoring and maintenance services ensure airports are always prepared for emergency situations, protecting passengers, staff, and critical infrastructure.',
    shortDescription: 'Fire safety, emergency communication, and crisis management solutions',
    products: ['Fire Detection Systems', 'Emergency Communication', 'Mass Notification', 'Crisis Management'],
    categories: ['Emergency Response', 'Terminal Equipment'],
    location: 'Kuala Lumpur',
    country: 'Malaysia',
    website: 'https://emergency-response-asia.example.com',
    email: 'info@emergency-response-asia.com',
    phone: '+60 3 2345 6789',
    founded: '2003',
    employees: '100-200',
    certifications: ['ISO 9001', 'NFPA Certified', 'FM Approved', 'UL Listed'],
    featured: false,
    images: [IMAGES.SECURITY_TECH_4, IMAGES.AIRPORT_TERMINAL_5, IMAGES.AVIATION_2],
  },
  {
    id: 'asia-pacific-security',
    name: 'Asia Pacific Security Group',
    logo: IMAGES.SECURITY_TECH_5,
    description: 'Asia Pacific Security Group offers integrated security solutions combining physical security, electronic security, and security consulting services for airports. We provide end-to-end security system design, implementation, and management. Our expertise covers perimeter intrusion detection, vehicle screening, cargo security, and security risk assessments. With regional offices across Asia, we deliver localized support with global standards. Our multidisciplinary team includes security consultants, engineers, and former aviation security professionals who understand the unique challenges of airport security operations.',
    shortDescription: 'Integrated security solutions for airports across Asia Pacific region',
    products: ['Perimeter Security', 'Vehicle Screening', 'Cargo Security', 'Security Consulting'],
    categories: ['Security Screening', 'Access Control', 'Surveillance Systems'],
    location: 'Manila',
    country: 'Philippines',
    website: 'https://apac-security.example.com',
    email: 'contact@apac-security.com',
    phone: '+63 2 8765 4321',
    founded: '2000',
    employees: '500-1000',
    certifications: ['ISO 9001', 'ISO 27001', 'ASIS Certified', 'CPP Certified'],
    featured: false,
    images: [IMAGES.SECURITY_TECH_5, IMAGES.SECURITY_SCREENING_8, IMAGES.AIRPORT_TERMINAL_5],
  },
  {
    id: 'smart-airport-technologies',
    name: 'Smart Airport Technologies',
    logo: IMAGES.AVIATION_2,
    description: 'Smart Airport Technologies develops IoT-enabled security and operational solutions for next-generation airports. Our smart sensor networks, AI-powered analytics platforms, and integrated command centers provide real-time visibility across all airport operations. We specialize in predictive maintenance for security equipment, automated threat detection, and data-driven decision support systems. Our cloud-based platforms enable airports to optimize security resource allocation, reduce operational costs, and improve overall security effectiveness through advanced data analytics and machine learning.',
    shortDescription: 'IoT-enabled security and operational solutions for next-generation airports',
    products: ['IoT Sensors', 'AI Analytics', 'Command Centers', 'Predictive Maintenance'],
    categories: ['Cybersecurity', 'Surveillance Systems', 'Terminal Equipment'],
    location: 'Taipei',
    country: 'Taiwan',
    website: 'https://smart-airport-tech.example.com',
    email: 'info@smart-airport-tech.com',
    phone: '+886 2 2345 6789',
    founded: '2015',
    employees: '50-100',
    certifications: ['ISO 27001', 'AWS Certified', 'Azure Certified', 'SOC 2 Type II'],
    featured: false,
    images: [IMAGES.AVIATION_2, IMAGES.SECURITY_TECH_4, IMAGES.AIRPORT_TERMINAL_5],
  },
];

export const FEATURED_SUPPLIERS = SUPPLIERS.filter(supplier => supplier.featured);
